import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.mjs';
import { __rest } from '/Users/gimboseog/development/moim-frontend/node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { useInView } from 'react-intersection-observer';
import { isServer } from '../helpers/envChecker/index.mjs';

var LazyLoad = /*#__PURE__*/React.memo(function (_a) {
  var onVisible = _a.onVisible,
    children = _a.children,
    _a$width = _a.width,
    width = _a$width === void 0 ? "100%" : _a$width,
    _a$height = _a.height,
    height = _a$height === void 0 ? "100%" : _a$height,
    placeholder = _a.placeholder,
    options = __rest(_a, ["onVisible", "children", "width", "height", "placeholder"]);
  var _useInView = useInView(Object.assign({
      triggerOnce: true
    }, options)),
    _useInView2 = _slicedToArray(_useInView, 2),
    ref = _useInView2[0],
    inView = _useInView2[1];
  var style = React.useMemo(function () {
    return {
      width: width,
      height: height
    };
  }, [width, height]);
  React.useLayoutEffect(function () {
    if (inView && onVisible) {
      onVisible();
    }
  }, [inView, onVisible]);
  return isServer() || inView ? jsx(React.Fragment, {
    children: children
  }) : jsx("div", {
    ref: ref,
    style: style,
    children: placeholder
  });
});

export { LazyLoad };
